import type { TefComs4p } from '@mfe/components/TefComs4p';
import { componentStateStore } from '@mfe/store';
import { html } from 'lit';

//
// renders the main compoennt view
//
export const tefComs4pEdit = function render(this: TefComs4p)
  : ReturnType<typeof html> {
  return html`
    <one-stack gap="sm">
      <one-content>
        <one-heading level="h4" variant="default">Partner-APP Einstellungen</one-heading>
        <one-text as="p">
          Im Folgenden können Sie die Einstellungen Ihrer Partner-APP für Ihre Rufnummern einsehen und ändern.   
        </one-text>
        ${this.getTemplateFn('singlePurposeEdit')(componentStateStore.activePurpose)}
      </one-content>
      <one-content>
        <one-group position="apart" align-items="center" wrap="nowrap">
          <tef-coms-cancel-button text="Abbrechen"></tef-coms-cancel-button>
          <one-button variant="solid" size="medium" type="button" @click=${this.saveConsentsForActivePurpose}>Speichern</one-button>
        </one-group>
      </one-content>
    </one-stack>
  `;
};
